import Dispatcher from './Dispatcher.js';
import Constants from './Constants.js';
import PopupStore from './Stores/PopupStore.js';
import NewsStore from './Stores/NewsStore.js';
import PopupActions from './Actions/PopupActions.js';
import NewsActions from './Actions/NewsActions.js';

var popupStore = new PopupStore();
var newsStore = new NewsStore();

Dispatcher.register((action) => {

  switch(action.actionType) {
    case Constants.EVENT_POPULATE_POPUP:
      popupStore.populate(action.people);
      break;

    case Constants.ACTION_OPEN_POPUP:
      popupStore.open(action.index);
      break;

    case Constants.ACTION_CLOSE_POPUP:
      popupStore.close();
      break;

    case Constants.ACTION_NAVIGATE_RIGHT:
      popupStore.navigateRight();
      break;

    case Constants.ACTION_NAVIGATE_LEFT:
      popupStore.navigateLeft();
      break;

    case Constants.ACTION_OPEN_NEWS:
      newsStore.openPanel();
      break;

    case Constants.ACTION_CLOSE_NEWS:
      newsStore.closePanel();
      break;

    default:
      throw new Error(`Unrecognised actionType "${action.actionType}"`);
  }
});

var App = {
  'peoplePopup': {
    'store': popupStore,
    'actions': PopupActions
  },
  'newsPanel': {
    'store': newsStore,
    'actions': NewsActions
  }
};

export default App;
